import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { PawPrint } from "lucide-react";
import { api } from "@/lib/api";
import { LEAD_MODAL } from "@/constants/testIds";

export const LeadCaptureModal = ({ open, onOpenChange }) => {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || mobile.trim().length < 8) {
      toast.error("Please enter a valid name and mobile number.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/leads", { name, mobile, source: "popup" });
      toast.success("Thank you! We'll reach out to you shortly.");
      setName("");
      setMobile("");
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={LEAD_MODAL.dialog} className="max-w-3xl p-0 overflow-hidden rounded-[2rem] border-none">
        <div className="grid md:grid-cols-2">
          <div className="hidden md:block relative h-full min-h-[420px]">
            <img
              src="https://images.unsplash.com/photo-1591160690555-5debfba289f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"
              alt="Golden Retriever puppy"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <div className="p-8 md:p-10 bg-[#F9F8F6]">
            <PawPrint className="w-8 h-8 text-[#D97736] mb-4" />
            <DialogHeader>
              <DialogTitle className="font-display text-2xl md:text-3xl font-bold text-[#0F2520]">
                Get to know our Golden Retrievers
              </DialogTitle>
              <DialogDescription className="font-light text-[#0F2520]/70">
                Share your details and we'll personally connect with you about available puppies.
              </DialogDescription>
            </DialogHeader>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <Input
                data-testid={LEAD_MODAL.nameInput}
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="h-12 rounded-xl"
              />
              <Input
                data-testid={LEAD_MODAL.mobileInput}
                placeholder="Mobile Number"
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="h-12 rounded-xl"
              />
              <Button
                data-testid={LEAD_MODAL.submitBtn}
                type="submit"
                disabled={loading}
                className="w-full h-12 rounded-full bg-[#D97736] hover:bg-[#0F2520] text-white font-semibold"
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
